import * as React from "react";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import SummaryPDFDocument from "../ThankYou/SummaryPdf";
const generatePdfDocument = async (documentData, warrantyId, warrantyNumber) => {
    const blob = await pdf(<SummaryPDFDocument reviewData={documentData} warrantyId={warrantyId} warrantyNumber={warrantyNumber}/>);
    blob.updateContainer(<SummaryPDFDocument reviewData={documentData} warrantyId={warrantyId} warrantyNumber={warrantyNumber}/>);
    const result = await blob.toBlob();
    // saveAs(result, "Warranty-Summary_" + warrantyId + ".pdf");
    saveAs(result, "Warranty-Summary_" + warrantyNumber + ".pdf");
};

export default generatePdfDocument;
